const TRUSTED_COMMUNICATION_HOSTS: ReadonlySet<string> = new Set([
  "smartmanager.ai",
  "www.smartmanager.ai",
]);

/**
 * A platform communication's action address in its one canonical form: an
 * https page on a Smart Manager host, with no credentials and no fragment.
 * Null for anything else. The send path stores and signs this form
 * (docs/security/injection-quarantine.md, Q3), and the feed opens the same
 * form, so the bytes the client opens are the bytes the server signed.
 */
export function trustedCommunicationActionUrl(value: unknown): string | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    if (
      url.protocol !== "https:"
      || url.username
      || url.password
      || !TRUSTED_COMMUNICATION_HOSTS.has(url.hostname.toLowerCase())
    ) {
      return null;
    }
    url.hash = "";
    return url.toString();
  } catch {
    return null;
  }
}
